import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount.ts';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { MAX_USERNAME_LENGTH } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context.tsx';
import { userService } from '@/services/user';

import { LayoutDataType } from '../../types';

import { Image, Overlay, PageStyles, ImageContainer } from './Name.styles';

export const ScreenName: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const data = webCampaign.getLayoutNotes();
  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formName = form.watch('name');

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = (): void => {
    userService
      .createOrUpdate({
        name: formName,
      })
      .then(() => {
        refreshUser();
      });

    wizard.nextStep();
  };

  const getBackgroundSrc = () => {
    if (!data || data.length === 0)
      return `/assets/layout-own-ai-man-roleplay/s1.png`;

    const note = data[0];

    return `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/first-screen/${note}.png`;
  };

  return (
    <PageStyles background="dark-forest">
      <IonContent>
        <ImageContainer>
          <Image src={getBackgroundSrc()} />
          <Overlay
            src={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/overlay.png`}
          />
        </ImageContainer>
        <div className={'content'}>
          <OnboardingTitle className="onboarding-name-title">
            What does he call you?
          </OnboardingTitle>
          <OnboardingTitle className="onboarding-name-title">
            Your journey begins with a name.
          </OnboardingTitle>

          <div className="input-container">
            <FormInput
              form={form}
              hidden={false}
              onSubmit={handleNextStep}
              isShowButton={!!formName}
              ref={inputRef}
              name="name"
              type="text"
              placeholder="Type your name"
              theme={'roleplay'}
              maxLength={MAX_USERNAME_LENGTH}
            />
          </div>
        </div>
      </IonContent>
    </PageStyles>
  );
};
